import { render, staticRenderFns } from "./tableData.vue?vue&type=template&id=a58f445c&scoped=true&"
import script from "./tableData.vue?vue&type=script&lang=js&"
export * from "./tableData.vue?vue&type=script&lang=js&"
import style0 from "./tableData.vue?vue&type=style&index=0&id=a58f445c&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a58f445c",
  null
  
)

export default component.exports